module.exports = __webpack_public_path__ + "img/succcess.67159340.png";